import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {GnInputComponent} from './input.component';
import { NzInputModule } from 'ng-zorro-antd/input';
import {FormsModule} from '@angular/forms';


@NgModule({
  declarations: [GnInputComponent],
  exports: [GnInputComponent],
  imports: [
    CommonModule,
    NzInputModule,
    FormsModule
  ],
  entryComponents: []
})
export class GnInputModule {
}
